// extracted by mini-css-extract-plugin
export default {"valueWrapper":"Value-module_valueWrapper-_vg3I","value":"Value-module_value-wtF66","image":"Value-module_image-Qb6PM"};